import { render, staticRenderFns } from "./HomeFeed.vue?vue&type=template&id=4b2fa350&scoped=true&"
import script from "./HomeFeed.vue?vue&type=script&lang=js&"
export * from "./HomeFeed.vue?vue&type=script&lang=js&"
import style0 from "./HomeFeed.vue?vue&type=style&index=0&id=4b2fa350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2fa350",
  null
  
)

export default component.exports